import React, { Component, Fragment } from 'react';
import '../styles/Summary.scss';
import '../styles/CommonStyle.scss';
import loader from '../images/loader.gif';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import '../styles/CommonStyle.scss';
import { withTranslation } from 'react-i18next';
import { getPoolInformation } from '../services/tenant-identity-service';
import { getTokenDetailsByDecoding } from '../services/cookie-storage-service';

class Bill extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tenantData: {}
        };
    }

    componentDidMount = async () => {
        let tenantGuid = getTokenDetailsByDecoding().tenantGuid;
        let tenantData = await getPoolInformation(tenantGuid);
        this.setState({ tenantData: tenantData });
    }

    navigate = (e, path) => {
        this.props.history.push(path);
    }


    render() {
        const { t } = this.props;
        let purchaseButton = '';
        let tenantData = {};
        tenantData = this.state.tenantData;

        // if (tenantData) {
        //     if (tenantData.isPurchase) {
        //         purchaseButton = <div className="upgrade" onClick={(e) => { this.navigate(e, '/Subscription_Upgrade') }}>{t('UPGRADE NOW!')}</div>
        //     } else {
        //         purchaseButton = <div className="upgrade" onClick={(e) => { this.navigate(e, '/Language') }}>{t('PURCHASE NOW!')}</div>
        //     }
        // }


        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="dash-board-content-sec">
                                    {
                                        tenantData ? (
                                            <div className="summary-details">
                                                <div className="user-details">

                                                    {/* <img src={dp} className="img-fluid" alt="" />
                                                    <div className="inner">
                                                        {this.props.auth.isAuthenticated && this.props.auth.user && (
                                                            <h4 className="full-name">{this.props.auth.tenantUserName}</h4>
                                                        )}
                                                        <h6 className="user-name">username</h6>
                                                    </div> */}

                                                    {/* <h3 className="active-subscription">{t('Lorem ipsum dolor sit amet, consectetur adipiscing elit.')}</h3>
                                                    <h3 className="active-subscription">{t('Curabitur auctor massa lobortis, vehicula eros vel, commodo quam in Active Plan.')}</h3> */}
                                                    <div className="active-subscription-bill">{t('Lorem ipsum dolor sit amet, consectetur adipiscing elit.')}
                                                        <br></br>{t('Curabitur auctor massa lobortis,')}{t('vehicula eros vel,')}{t('commodo quam in')} <b>{t('Active Plan')}</b></div>
                                                    {/* <h4 className="plans">{t('You dont have any' )}<b>{t('Subscriptions')}</b>{t('yet!')}</h4> */}

                                                    {/* {
                                                        tenantData.languageCount === 0 || tenantData.locationCount === 0 ?
                                                            ( */}
                                                    <Fragment>

                                                        {/* <div className="summary-msg">{t('We will send the Pricing Quote to your registered email address at the earliest ')}<span>{t('The payment link also will updated below. For further enquiries,')}</span> {t('and')}<span>{t('Locations')}</span>{t('you required in your Plan.')}</div> */}

                                                        <div className="summary-msg">{t('We ll send the')}<span className=""><b>{t(' Pricing Quote ')}</b></span>{t('to your registered email address at the earliest.')}{t(' The payment link also will updated below.')}{t(' For further enquiries ,')}<span className="pointer"
                                                            onClick={() => { this.props.history.push('/Billing') }}>
                                                            {/* <a href="/Billing">{t('Let Us Know')}</a> */}
                                                            {t(' Let Us Know')}
                                                        </span></div>
                                                        {/* <NavLink className="upgrade" to='/Subscription_Upgrade'>
                                                            {
                                                                this.props.auth.tenantResult && this.props.auth.tenantResult.isPurchase === 'true' ? (
                                                                    'UPGRADE NOW'
                                                                ) : 'PURCHASE NOW!'
                                                            }
                                                        </NavLink> */}


                                                        {purchaseButton}

                                                    </Fragment>
                                                    {/* ) : null
                                                    } */}

                                                    <div className="summary-text">
                                                        {/* {t('Lorem ipsum dolor sit amet, consectetuer adipiscing elit.')}
                                                        <br />
                                                        {t('Ut wisi enim ad minim veniam.')} */}
                                                    </div>



                                                    <h3 className="statics">{t('YOUR BILL DETAILS')}
                                                    </h3>
                                                    <div className="summary-text-bill">{t('Waiting approval from sales team.')}</div>

                                                </div>
                                            </div>
                                        ) : (<img src={loader} alt="" className="loader" />)
                                        // (<div className="spinner">
                                        //     {/* <Spinner radius={120} color={"#333"} stroke={2} visible={true} /> */}
                                        //     <CircularProgress />
                                        // </div>)
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>
        )
    }
};
export default withTranslation()(Bill)